export { default as Logo, LogoMemoizedHOC } from './hocs';
